import { InstagramDashboard } from "components/InstagramData";
import SideMenu from "components/SideMenu";
import SectionHeading from "components/text/SectionHeading";
import { useAuth } from "providers/auth.provider";

export const SocialMetrics = () => {
  const { user } = useAuth();

  if (!user) {
    return <div>There was an error. Please contact support</div>;
  }

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-[240px_1fr]">
      <SideMenu />
      <main className="p-6">
        <div className="mb-6 flex items-center justify-between gap-3">
          <h1 className="text-2xl font-semibold tracking-tight">Socials</h1>
        </div>
        <div className="grid gap-4 mb-6">
          <SectionHeading
            title="Instagram"
            subtitle="Dive into your instagram metrics and audience behaviour"
          />
          <InstagramDashboard userId={user?.uid} />
        </div>
      </main>
    </div>
  );
};
